// Dispatches an ARSL/ATL/AE/ES "general invoice engine" invoice (from
// src/components/Dashboard.js) to the right normalizer based on its `type`
// field — each upload produces one "service" invoice (taxable) and one
// "reimbursement" invoice (pure cost passthrough) per segment, as two
// separate invoice numbers/PDFs, so each is approved and snapshotted
// independently.
import { normalizeHeadcountServiceInvoice } from "./headcountAdapter";
import { normalizeReimbursementInvoice } from "./reimbursementAdapter";

export function normalizeGeneralEngineInvoice(invoice) {
  if (invoice.type === "service") return normalizeHeadcountServiceInvoice(invoice);
  if (invoice.type === "reimbursement") return normalizeReimbursementInvoice(invoice);
  throw new Error(`Unknown general invoice engine type: ${invoice.type}`);
}
